import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../Styles/Otp_verification.css";
import { log_in } from "../api/serverWrapper";
import { PHNO } from "../utils/store-data-constants";
import { getData } from "../utils/store-data";
import { useMasterData } from "../context/MasterDataContext";
import { routeUserAfterLogin } from "../utils/loginNavigation";
import { useAccountStatusGate } from "../hooks/useAccountStatusGate";
import AccountStatusModals from "../hooks/AccountStatusModals";

const Otp_verification = () => {
  const [phoneNumber, setPhoneNo] = useState("");
  const { selectedCountryCode } = useMasterData();
  const navigate = useNavigate();
  const inputsRef = useRef([]);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const location = useLocation();

  // Single source of truth for the deleted/disabled account flow —
  // owns its own popup state + reactivate handler, nothing duplicated here.
  const {
    accountDeletedPopup,
    setAccountDeletedPopup,
    accountDisabledPopup,
    setAccountDisabledPopup,
    isEnabling,
    checkAccountStatus,
    handleReactivateAccount,
    deletedAccount,
    isDeletedBusy,
    handleReactivateDeleted,
    handleHardDeleteAndSignup,
  } = useAccountStatusGate();

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputsRef.current.length - 1) {
      inputsRef.current[index + 1].focus();
    }
    if (!value && index > 0) {
      inputsRef.current[index - 1].focus();
    }

    if (newOtp.every((digit) => digit !== "")) {
      login();
    }
  };

  useEffect(() => {
    loadPHno();
  }, []);

  async function loadPHno() {
    const phno = await getData(PHNO);
    setPhoneNo(phno);
  }

  const login = async () => {
    const phno = await getData(PHNO);
    const data = {
      PhoneNumber: phno,
      CountyCode: selectedCountryCode,
    };

    console.log(data);

    try {
      const resp = await log_in(data);
      console.log(resp);

      if (resp?.data && resp?.code === 200) {
        const user = resp.data;
        console.log(user);
        
        if (checkAccountStatus(user)) return;
        await routeUserAfterLogin(user, navigate, { replace: true });
      } else {
        navigate("/terms-and-conditions",{ replace: true });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="otp-page">
      {/* Left Panel */}
      <div className="left-panel">
        <div className="curve-image"></div>
        <img
          src={require("../assests/images/otp_verification_logo.png")}
          alt="WedLuk Logo"
          className="logo"
        />
        <p className="tagline">Matirmonial Nexus</p>
      </div>

      {/* Right Panel */}
      <div className="right-panel">
        <div className="otp-card">
          <h2>OTP Verification</h2>
          <div className="otp-boxes">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="otp-input"
                value={digit}
                ref={(el) => (inputsRef.current[index] = el)}
                onChange={(e) => handleInputChange(e, index)}
              />
            ))}
          </div>
          <p className="resend-text">Resend in 00:30</p>
        </div>
      </div>

      <AccountStatusModals
        accountDeletedPopup={accountDeletedPopup}
        setAccountDeletedPopup={setAccountDeletedPopup}
        accountDisabledPopup={accountDisabledPopup}
        setAccountDisabledPopup={setAccountDisabledPopup}
        isEnabling={isEnabling}
        handleReactivateAccount={handleReactivateAccount}
        deletedAccount={deletedAccount}
        isDeletedBusy={isDeletedBusy}
        handleReactivateDeleted={handleReactivateDeleted}
        handleHardDeleteAndSignup={handleHardDeleteAndSignup}
      />
    </div>
  );
};

export default Otp_verification;
